module.exports = __webpack_public_path__ + "img/post_sample_facebook.0394958f.png";